module.exports = __webpack_public_path__ + "img/product_77.8d05e10.webp";